import React from 'react'
import Layout from 'components/Layout/Layout'
import { MetaLayout } from 'components'
import Register from 'views/Register/Register'

const Index = () => {
  return (
    <MetaLayout
      title="Register and order for fast and professional service in St. Kitts,
      Nevis, Grenada, Dominica"
      description="Register and order for fast and professional service in St. Kitts,
      Nevis, Grenada, Dominica"
    >
      {<Register />}
    </MetaLayout>
  )
}

Index.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

export default Index
